export default {
    beforeMount() {
        this.hideTopSection();
        this.hideBottomSection();
    },
    methods: {
        hideTopSection() {
            const calculationInfoContainer = document.getElementById('calculation-info-container');
            if (calculationInfoContainer) {
                calculationInfoContainer.style.display = 'none';
            }
        },
        hideBottomSection() {
            const calculationInfoContainer = document.getElementById('calculation-bottom-container');
            if (calculationInfoContainer) {
                calculationInfoContainer.style.display = 'none';
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/calculation/calculator/mixins/calculation.mixin.js